import { useCabinetText } from "../../content/CabinetContentContext";
import { useEffect, useRef, useState } from "react";
import {
  markRead,
  sendMessage,
  subscribeMessages,
} from "../../chat/chatService";
import { auth } from "../../firebase";
import CloseButton from "../common/CloseButton";
export default function UserChat({ uid, onClose }) {
  const t = useCabinetText("chat");
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const listRef = useRef(null);
  // Закривати по Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  useEffect(() => {
    if (!uid) return;
    const unsub = subscribeMessages(uid, (list) => {
      setMsgs(list);
      setTimeout(() => {
        listRef.current?.scrollTo({
          top: listRef.current.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    });
    // позначити прочитаним для користувача
    markRead(uid, "user");
    return () => unsub && unsub();
  }, [uid]);

  const onSend = async () => {
    await sendMessage(uid, {
      text,
      from: "user",
      senderId: auth?.currentUser?.uid || uid,
    });
    setText("");
  };

  return (
    <div
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        width: 360,
        maxHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ddd",
        borderRadius: 12,
        background: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          padding: "10px 12px",
          borderBottom: "1px solid #eee",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontWeight: 700 }}>{t("text001")}</div>
        <CloseButton onClick={onClose} />
      </div>

      <div
        ref={listRef}
        style={{
          flex: 1,
          overflow: "auto",
          padding: 12,
          background: "#fafafa",
        }}
      >
        {msgs.map((m) => (
          <div
            key={m.id}
            style={{
              display: "flex",
              justifyContent: m.from === "user" ? "flex-end" : "flex-start",
              marginBottom: 8,
            }}
          >
            <div
              style={{
                maxWidth: "70%",
                padding: "8px 12px",
                borderRadius: 12,
                background: m.from === "user" ? "#3e51c1" : "#fff",
                color: m.from === "user" ? "#fff" : "#000",
                border:
                  m.from === "user" ? "1px solid #3e51c1" : "1px solid #eee",
              }}
            >
              {m.text}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          padding: 10,
          borderTop: "1px solid #eee",
          display: "flex",
          gap: 8,
        }}
      >
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t("text002")}
          onKeyDown={(e) => e.key === "Enter" && text.trim() && onSend()}
          style={{
            flex: 1,
            border: "1px solid #ddd",
            borderRadius: 10,
            padding: "10px 12px",
          }}
        />
        <button
          onClick={onSend}
          disabled={!text.trim()}
          style={{
            background: "#3e51c1",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
          }}
        >{t("text003")}</button>
      </div>
    </div>
  );
}
